// @ts-check
import React from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import useLeftHandLayout from 'containers/LeftHandLayout/context';
import { useNavTopInnerX, useNavTopOuterY, useNavTopSize } from '../navSetter';
import BasketAdmin from './contents/BasketAdmin';
import LogoutOnly from './contents/LogoutOnly';
import Standard from './contents/Standard';
import Suspended from './contents/Suspended';
import Unauthed from './contents/Unauthed';

const LargeNavContent = () => {
	const { roles } = useLeftHandLayout();

	if (!roles.loggedIn) {
		return <Unauthed />;
	}

	if (roles.loggedIn && roles.basketAdmin) {
		return <BasketAdmin />;
	}

	if (roles.loggedIn && !roles.accountLogin) {
		return <LogoutOnly />;
	}

	if (roles.suspended) {
		return <Suspended />;
	}

	return <Standard />;
};

const TOPNAV_SIZE_PX = 64;
const TOPNAV_INNER_X_PX = 16;
const TOPNAV_OUTER_Y_PX = 8;

export function LargeNav() {
	const { leftSize } = useLeftHandLayout();

	useNavTopSize(TOPNAV_SIZE_PX);
	useNavTopInnerX(TOPNAV_INNER_X_PX);
	useNavTopOuterY(TOPNAV_OUTER_Y_PX);

	return (
		<Stack
			component="nav"
			overflow="hidden"
			position="fixed"
			top={0}
			left={leftSize}
			right={0}
			padding={`${TOPNAV_OUTER_Y_PX}px`}
			paddingBottom={0}
			bgcolor={(theme) => theme.palette.uc.bg.weak}
			zIndex={(theme) => theme.zIndex.appBar}
		>
			<Stack
				height={TOPNAV_SIZE_PX}
				direction="row"
				padding={`${TOPNAV_INNER_X_PX}px`}
				alignItems="center"
				useFlexGap
				gap={200}
				borderRadius={(theme) =>
					`${theme.borderRadius.roundedSm} ${theme.borderRadius.roundedSm} 0 0`
				}
				borderBottom={(theme) => `1px solid ${theme.palette.uc.border.weak}`}
				bgcolor={(theme) => theme.palette.uc.bg.main}
				boxShadow={1}
			>
				<LargeNavContent />
			</Stack>
		</Stack>
	);
}

export default LargeNav;
